import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';

@Injectable({
  providedIn: 'root',
})
export class ExcelExportService {
  exportToExcel<T>(data: T[], fileName: string): void {
    if (data.length === 0) {
      throw new Error('No data to export');
    }

    // Create a worksheet
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

    // Create a workbook
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet);

    // Write to file and trigger download
    XLSX.writeFile(
      workbook,
      `${fileName + '_' + Math.floor((Date.now() / 100) * 10)}.xlsx`
    );
  }
}
